export default __webpack_public_path__ + "static/media/2.8b8f12d8.jpg";